// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__FI_tT","label":"Category_label__2tROW","content":"Category_content__1WCtg","header":"Category_header__28HOR","location":"Category_location__2CEAE"};